<template>
    <v-dialog v-model="dialog" persistent hide-overlay fullscreen content-class="d-flex justify-center align-center background-modal">
        <v-card  class="variable-container elevation-15">
        <div
            class="d-flex flex-column justify-center align-center higlight-type-content position-relative"
        >
            <v-btn color="primary" icon class="position-absolute btn-cls" @click="close">
                <v-icon color="primary">mdi-close-circle</v-icon>
            </v-btn>
            <img
                :src="`https://assets.beereaders.com/lingual_variable_image/${main_idiom.urlImg}`"
                alt="imgen de variable linguistica"
                class="rounded-circle variable-img position-absolute elevation-5"
            />
            <div class="d-flex flex-column justify-center align-center position-relative pa-8 title-container">
                <div class="py-3 d-flex flex-column justify-center align-center" v-if="main_idiom">
                    <span class="text-word-subtitle-2">La palabra...</span>
                    <span class="text-word-subtitle-1 primary--text font-weight-bolder">“{{main_idiom.word}}”</span>
                </div>
            </div>
            <div class="scroll-panel">
                <v-list-item v-for="(item, index) of main_idiom.countries" :key="index" :id="`item-country-${item.country.id}`" class="scroll-item">
                    <v-list-item-avatar>
                        <img
                            :src="`https://assets.beereaders.com/countries_flags/${item.country.isoCode}.png`"
                            alt=" country-flag"
                            class="border-radius-1 country-img"
                        />
                    </v-list-item-avatar>
                        
                    <v-list-item-content>
                        <v-list-item-title class="text-subtitle-1">En <b>{{item.country.name}}</b> {{`se refiere a "${item.word}".`}}</v-list-item-title>
                    </v-list-item-content>

                </v-list-item>
            </div>
        </div>
        </v-card>
        
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */
import SplashContent from '@/components/reading/core/SplashContent.vue'
import CountryFlag from '@/components/reading/core/CountryFlag.vue'

export default {
    components: {
        SplashContent,
        CountryFlag,
    },
    props: {
        dialog: { type: Boolean, default: false },
        main_idiom: { type: Object, default: null },
        current_country: { type: [Number, String], default: '' },
        userCountryId: { type: Number, default: null }
    },
    computed: {
        
        currentCountry() {
            const vm = this
            const result = vm.main_idiom.countries.find(
                (el) => el.id === Number(vm.current_country_id)
            )
            return result || vm.main_idiom.countries[0]
        },
        items () {
            return this.main_idiom.countries.map((value, index) => {
                return {
                    index,
                    item: value
                }
            })
        },
    },
    data() {
        return {
            usedImg: require('@/assets/img/icons/reading/highlight/icon-check.svg'),
            scrollValue: 0
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
        setCountry(id) {
            this.current_country_id = id
        },
    },
 
    beforeMount() {
        const vm = this
        const countrySelected = vm.main_idiom.countries.find(el => el.id === vm.current_country_id)

        if(!countrySelected) {
            const firstCountry = vm.main_idiom.countries[0]
            vm.current_country_id = firstCountry.id
            return            
        }

        vm.current_country_id = countrySelected.id
    },
    mounted() {
        const userCountryIdElement = `item-country-${this.userCountryId}`;
        const userCountryHTML = document.getElementById(userCountryIdElement);
        userCountryHTML?.scrollIntoView();
    },
}
</script>
<style>

.main-idiom-img .variable-img {
    z-index: 10;
}

.variable-img {
    width: 130px;
    height: 130px;
    left: 35px;
    top: -35px;
}

.scroll-panel{
    max-height: 220px;
    width: 100%;
    overflow: auto;
    padding-left: 30px;
    padding-right: 30px;
}

.country-flag img {
    width: 7.5vh;
}
.country-flag.active img{
    border: 3px solid #514773;
}

.variable-container {
    min-height: 430px !important;
    min-width: 300px !important;
    max-width: 500px;
    margin: 0!important;
    padding: 0!important;
    border-radius: 20px !important;
}

.background-modal {
    background-color: #5147739c;
}

.scroll-item{
    margin-top: 20px;
    margin-bottom: 20px;
    height: 60px;
    text-align: initial;
    font-style: normal !important;
    background-color: #d9d1ec;
    border-radius: 10px;
}

.text-word-subtitle-1 {
    font-size: 35px;
}

.text-word-subtitle-2 {
    font-size: 20px;
    color: #2BBAC3;
}

.title-container {
    width: 98%;
    box-shadow: 0px 6px 15px rgb(182, 182, 182);
}

.country-img{
    height: 30px !important;
}

</style>
